import { combineReducers } from 'redux';
import entryReducer from './entryReducer';
import linkAccountReducer from './linkAccountReducer';
import conflictResolveReducer from './conflictResolveReducer';

export default combineReducers({
  entry: entryReducer,
  linkAccount: linkAccountReducer,
  conflictResolve: conflictResolveReducer,
});
